import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getPermissionCategory, resetPermissionCategoryState } from "../../../store/permissionCategory/action";

import { getClient, resetClientState } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetAttendanceState, getAttendance as onGetAttendances, addNewAttendance as onAddNewAttendance, updateAttendance as onUpdateAttendance, deleteAttendance as onDeleteAttendance, getAttendanceLoading } from "../../../store/attendance/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const AttendanceSummary = () => {
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, employeeLoading, employees, attendances, isAttendanceCreated, isAttendanceSuccess, loading, error, permissionCategories, permissionCategoryLoading, clients, clientLoading, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    attendances: state.Attendance.attendances,
    isAttendanceCreated: state.Attendance.isAttendanceCreated,
    isAttendanceSuccess: state.Attendance.isAttendanceSuccess,
    loading: state.Attendance.loading,
    permissionCategories: state.PermissionCategory.permissionCategories,
    permissionCategoryLoading: state.PermissionCategory.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Attendance.error,
  }));

  const [attendanceList, setAttendanceList] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [permissionCategoryList, setPermissionCategoryList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [info, setInfo] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [pageIdx, setPageIdx] = useState(0);
  const [attendanceDoc, setAttendanceDoc] = useState([]);

  const typeOptionsList = [
    {
      label: "Jam Masuk",
      value: "clock_in",
    },
    {
      label: "Jam Pulang",
      value: "clock_out",
    },
    {
      label: "Jam Mulai Istirahat",
      value: "break_in",
    },
    {
      label: "Jam Selesai Istirahat",
      value: "break_out",
    },
    {
      label: "Jam Masuk Lembur",
      value: "over_in",
    },
    {
      label: "Jam Keluar Lembur",
      value: "over_out",
    },
  ];

  const onClickDelete = (attendance) => {
    setAttendance(attendance);
    setDeleteModal(true);
  };

  const handleDeleteAttendance = () => {
    if (attendance) {
      dispatch(onDeleteAttendance(attendance));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setAttendanceList(attendances);
  }, [attendances]);

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetAttendanceState());
      dispatch(onGetAttendances({ companyId: companySelected?.value ?? "", type: "summary" }));
      dispatch(resetPermissionCategoryState());
      dispatch(getPermissionCategory());
      handleGetEmployee(companySelected?.value ?? "");
    }
  }, [companySelected]);

  useEffect(() => {
    setAttendance(attendances);
  }, [attendances]);

  useEffect(() => {
    if (!isEmpty(attendances)) {
      setAttendance(attendances);
      setAttendanceList(attendances);
      setInfo(attendances[attendances.length - 1]);
      setIsEdit(false);
    }
  }, [attendances]);

  useEffect(() => {
    setAttendanceList(attendances);
  }, [attendances]);

  useEffect(() => {
    if (!isEmpty(attendances)) setAttendanceList(attendances.map((el) => ({ ...el, isChecked: false })));
  }, [attendances]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "department",
        label: "Departemen",
        isSelected: true,
        data: [],
      },
    ];

    if (attendanceList.length > 0) {
      attendanceList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "department") {
                doc.data.push(`${value} - ${data.position}`);
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "attendance") {
                value?.forEach((item) => {
                  const exists = dataDoc.find((d) => d.id === item.date);

                  let val = "✗";

                  if (item.attend && item.attend.clocks > 0) {
                    val = "✓";
                  } else if (item.attend && item.attend.clockinat && !item.attend.clockoutat) {
                    val = "✓";
                  }

                  if (!exists) {
                    dataDoc.push({
                      id: item.date,
                      label: item.date,
                      isSelected: true,
                      data: [val],
                    });
                  } else {
                    exists.data.push(val);
                  }
                });
              }
            }
          });
        }
      });
    }

    setAttendanceDoc(dataDoc);
  }, [attendanceList]);

  useEffect(() => {
    if (!isEmpty(permissionCategories)) {
      var permissionCategoryData = [];
      var opt = [];
      permissionCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const type = item.type;
        if (item.type === "attendance") {
          var obj = {
            label: name,
            value: id,
            type: type,
          };
          opt.push(obj);
        }
      });
      var option = { options: opt };
      permissionCategoryData.push(option);
      setPermissionCategoryList(permissionCategoryData);
    }
  }, [permissionCategories]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(resetEmployeeState());
    validation.setFieldValue("employee", "");
    setEmployeeList([]);
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.userId;
      const position = item?.employee_user?.user_position && item?.employee_user?.user_department ? { label: `${item?.employee_user?.user_position?.name}, ${item?.employee_user?.user_department?.name}`, value: item?.employee_user?.user_position?.id, departmentId: item?.employee_user?.user_department?.id } : "";
      let branchId = null;
      if (item?.employee_user?.user_location?.length > 0) {
        item?.employee_user?.user_location?.forEach((element) => {
          if (element.isPrimary) {
            branchId = element.branchId;
          }
        });
      }
      var obj = { label: name, value: id, position: position, branchId: branchId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAttendance(null);
    } else {
      dispatch(getClient());
      setModal(true);
    }
  }, [modal]);

  const defaultdate = () => {
    return moment().format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "summary",
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetAttendances(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAttendanceList([]);
    setSearchValue("");
    dispatch(resetAttendanceState());
    dispatch(onGetAttendances({ companyId: companySelected?.value ?? "", type: "summary" }));
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (attendance && attendance.client) || clientSelected,
      company: (attendance && attendance.company) || companySelected,
      employee: (attendance && attendance.employee) ?? "",
      startat: (attendance && attendance.startat) ?? "",
      permissionCategory: (attendance && attendance.permissionCategory) ?? "",
      type: (attendance && attendance.type) ?? "",
    },
    validationSchema: Yup.object({
      permissionCategory: Yup.object().required("Please Pick permissionCategory"),
      employee: Yup.object().required("Please Pick Employee"),
      startat: Yup.string().required("Please Pick Effective Date"),
      //type: Yup.object().required("Please Pick Type"),
    }),
    onSubmit: (values) => {
      dispatch(getAttendanceLoading());
      if (isEdit) {
        const updateAttendance = {
          id: attendance ? attendance.id : 0,
          startat: values.startat,
          permissionCategoryId: values.permissionCategory.value,
          userId: values.employee.value,
          branchId: values.employee.branchId,
          companyId: values.company.value,
          clientId: values.client.value,
          type: values.type.value,
        };

        dispatch(onUpdateAttendance(updateAttendance));
        validation.resetForm();
      } else {
        const newAttendance = {
          startat: values.startat,
          permissionCategoryId: values.permissionCategory.value,
          userId: values.employee.value,
          branchId: values.employee.branchId,
          companyId: values.company.value,
          clientId: values.client.value,
          type: "clock_in",
        };
        dispatch(onAddNewAttendance(newAttendance));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAll = () => {
    const allChecked = attendanceList.every((item) => item.isChecked);
    const updatedData = attendanceList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setAttendanceList(updatedData);
  };

  document.title = "Rekap Kehadiran | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={attendanceList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAttendance} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Penggajian" pageTitle="Rekap Kehadiran" loading={loading}>
          <ExportDoc data={attendanceDoc} />
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card id="attendanceList">
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  setAttendanceList(attendances.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase())));
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`Cari Karyawan`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setAttendanceList(attendances.filter((item) => item.department.toLowerCase().includes(e.target.value.toLowerCase()) || item.position.toLowerCase().includes(e.target.value.toLowerCase())));
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`Cari Divisi / Departemen`}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card tableFixHead mb-0 mt-3">
                    <Table className="table-border text-center table-nowrap align-middle mb-0">
                      <thead>
                        <tr className="table-active">
                          <th scope="col" className="text-start fs-14 sticky-col" style={{ background: "#FFFFFF", left: "0px", top: "0px", zIndex: 101 }}>
                            <div style={{ width: "30px" }}>
                              <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={attendanceList.every((item) => item.isChecked)} onChange={checkedAll} />
                            </div>
                          </th>
                          <th scope="col" className="text-start fs-14 sticky-col" style={{ background: "#FFFFFF", left: "0px", top: "0px", zIndex: 101 }}>
                            <div style={{ width: "260px" }}>KARYAWAN</div>
                          </th>
                          <th scope="col" className="text-start fs-14 sticky-col" style={{ background: "#FFFFFF", left: "260px", top: "0px", zIndex: 101 }}>
                            <div style={{ width: "320px" }}>DEPARTEMEN</div>
                          </th>
                          <th scope="col" className="text-start fs-14 sticky-col" style={{ background: "#FFFFFF", left: "580px", top: "0px", zIndex: 101 }}>
                            <div style={{ width: "40px" }}>H</div>
                          </th>
                          {(attendanceList && attendanceList.length > 0 ? attendanceList[0].attendance : []).map((element, index) => {
                            return (
                              <th scope="col" className="text-center fs-13 border-end" key={index}>
                                {element.date.substring(5, 10)}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {(attendanceList || []).map((element, index) => {
                          return (
                            <Fragment key={index}>
                              <tr>
                                <td className="text-start fw-semibold fs-13 sticky-col" style={{ background: "#FFFFFF", left: "0px", zIndex: 1 }}>
                                  <div style={{ width: "30px" }}>
                                    <input
                                      type="checkbox"
                                      className="dataCheckbox me-2 form-check-input"
                                      checked={element.isChecked}
                                      onChange={() => {
                                        const updatedData = attendanceList.map((d, i) => (i === index ? { ...d, isChecked: !d.isChecked } : d));
                                        setAttendanceList(updatedData);
                                      }}
                                    />
                                  </div>
                                </td>
                                <td className="text-start fw-semibold fs-13 sticky-col" style={{ background: "#FFFFFF", left: "0px", zIndex: 1 }}>
                                  <div style={{ width: "260px" }}>{element.name}</div>
                                </td>
                                <td className="text-start fs-13 sticky-col" style={{ background: "#FFFFFF", left: "260px", zIndex: 1 }}>
                                  <div style={{ width: "320px", overflow: "hidden" }}>
                                    {element.department} <br /> {element.position}
                                  </div>
                                </td>
                                <td className="text-start fs-14 sticky-col fw-semibold" style={{ background: "#FFFFFF", left: "580px", zIndex: 1 }}>
                                  <div style={{ width: "40px" }}>{(element.attendance || []).filter((a) => a.attend && a.attend.clockinat).length > 0 ? (element.attendance || []).filter((a) => a.attend && a.attend.clockinat).length : " - "}</div>
                                </td>
                                {(element.attendance || []).map((el, idx) => {
                                  return (
                                    <td className="text-start fw-semibold" key={idx}>
                                      <i className={el.attend && el.attend.clocks > 0 ? "mt-2 fs-20 ri-check-double-line fw-semibold text-success me-1" : el.attend && el.attend.clockinat && !el.attend.clockoutat ? "mt-2 fs-20 ri-check-line fw-semibold text-info me-1" : "mt-2 fs-20 text-danger ri-close-line me-1"}></i>
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Kehadiran" : "Tambah Kehadiran"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="mb-3">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp;
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  setCompanyList([]);
                                  validation.setFieldValue("company", "");
                                  validation.setFieldValue("client", e);
                                  handleGetCompany(e.value);
                                }}
                                options={clientList}
                              ></Select>
                            </div>

                            <div className="mb-3">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp;
                                {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  validation.setFieldValue("company", e);
                                  handleGetEmployee(e.value);
                                }}
                                options={companyList}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="employee-field" className="form-label">
                                Karyawan <span className="text-danger">*</span>&nbsp;
                                {employeeLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}
                              </Label>
                              <Select
                                name="employee"
                                value={validation.values.employee}
                                placeholder="Pilih Karyawan"
                                isDisabled={employeeList.length > 0 ? false : true}
                                onChange={(e) => {
                                  validation.setFieldValue("oldposition", e.position);
                                  validation.setFieldValue("employee", e);
                                  // handleGetPosition(e.userId);
                                  // handleGetEmployee(e.value);
                                }}
                                options={employeeList}
                              ></Select>
                              {validation.touched.employee && validation.errors.employee ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.employee}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="permissionCategory" className="form-label">
                                Kategori
                                {permissionCategoryLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="permissionCategory"
                                value={validation.values.permissionCategory}
                                placeholder="Pilih Kategori"
                                onChange={(e) => {
                                  validation.setFieldValue("permissionCategory", e);
                                }}
                                options={permissionCategoryList}
                                noOptionsMessage={(e) => "Type PermissionCategory to get option"}
                                invalid={validation.touched.permissionCategory && validation.errors.permissionCategory ? true : false}
                              ></Select>
                              {validation.touched.permissionCategory && validation.errors.permissionCategory ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.permissionCategory}
                                </p>
                              ) : null}
                            </div>
                            {!!isEdit && (
                              <div className="mb-3">
                                <Label htmlFor="type" className="form-label">
                                  Tipe
                                </Label>
                                <Select
                                  name="type"
                                  value={validation.values.type}
                                  placeholder="Enter Jenis"
                                  onChange={(e) => {
                                    validation.setFieldValue("type", e);
                                  }}
                                  options={typeOptionsList}
                                  invalid={validation.touched.type && validation.errors.type ? true : false}></Select>
                                {validation.touched.type && validation.errors.type ? (
                                  <p className="text-danger" type="invalid">
                                    {validation.errors.type}
                                  </p>
                                ) : null}
                              </div>
                            )}
                            <div className="mb-3">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Kehadiran
                              </Label>
                              <Flatpickr
                                name="startat"
                                className="form-control"
                                placeholder="Pilih Tanggal"
                                options={{ enableTime: true, time_24hr: true, altInput: true, altFormat: "Y/m/d H:i", dateFormat: "Y/m/d H:i" }}
                                value={validation.values.startat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("startat", e);
                                }}
                              />
                              {validation.touched.startat && validation.errors.startat ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.startat}
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="reason">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AttendanceSummary;
